<template>
  <div id="CollegeEvent">
      <div class="college_wrap">
        <img class="college_mobile" src="../assets/img/college/college_event.jpg" alt="">
      </div>
      <div class="college_wrap2">
        <img class="college_mobile" src="../assets/img/college/college_mid_bg.jpg" alt="">
      </div>
      <div class="college_wrap3">
        <img class="college_mobile" src="../assets/img/college/college_bot_bg.jpg" alt="">
      </div>
      <img class="college_button" src="../assets/img/college/college_button.png" alt=""  style="cursor: pointer;" @click="goToDetail()">
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },

  created() {
  },

  computed: {
    user() {
      return this.$store.state.user;
    }   
  },

  methods: {
    goToDetail() {
      this.$router.push({ path: "/bustour", query: {} });
    }
  }
}

</script>

<style scoped>
  #CollegeEvent{
    margin-top: -56px;
  }
  .college_wrap {
    margin: 0 auto;
    max-width: 2000px;
    background-color: black;
    height: 800px;
    background: url(../assets/img/college/college_top_bg.jpg) top no-repeat;
  }

  .college_wrap2 {
    max-width: 2000px;
    margin: 0 auto;
    background-color: black;
    height: 210px;
    background: url(../assets/img/college/college_mid_bg.jpg) top no-repeat;
  }

  .college_wrap3 {
    max-width: 2000px;
    margin: 0 auto;
    background-color: black;
    height: 1185px;
    background: url(../assets/img/college/college_bot_bg.jpg) top no-repeat;
  }

  .college_mobile{
    display: none;
  }
  .college_button{
    width: 300px;
    z-index: 2;
    position: relative;
    bottom: 150px;
    left: 50%;
    transform: translate(-50%);
  }

  @media(max-width:1024px){
    #CollegeEvent{
      margin-top: 2rem;
    }
    .college_mobile{
    width: 100%;
    display: block;
    height: auto;
    }
    .college_button{
        width: 40%;
    }
    .college_wrap {
      margin: 0 auto;
      max-width: 2000px;
      background-color: black;
      height: auto;
    }
    .college_wrap2 {
      display: none;
    }
    .college_wrap3 {
      display: none;
    }
    .college_button{
      width: 45%;
      z-index: 2;
      position: relative;
      bottom: 80px;
      left: 50%;
      transform: translate(-50%);
    }
  }
</style>